module.exports = __webpack_public_path__ + "static/img/9.56a8177.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/9.jpeg
// module id = OPAm
// module chunks = 0